import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading-overlay"
}
const _hoisted_2 = { class: "loading-spinner" }
const _hoisted_3 = { class: "loading-text" }


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingSpinner',
  props: {
    show: { type: Boolean },
    message: { default: 'Loading...' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (__props.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "spinner" }, null, -1)),
          _createElementVNode("p", _hoisted_3, _toDisplayString(__props.message), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})